export default class CurrencyUtils {
    static convertToCurrency(currencyAsNumber: number) {
        return `£${currencyAsNumber/100}`;
    } 
}